import {SVGAttributes} from 'react';

export default function CartIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.1358 0.0250001C2.36319 0.0271801 2.58267 0.10879 2.75626 0.25568C2.9296 0.40235 3.0463 0.60492 3.08625 0.82843L2.1358 0.0250001ZM2.1358 0.0250001H2.13484H1C0.737665 0.0250001 0.525 0.23766 0.525 0.5C0.525 0.76234 0.737665 0.975 1 0.975H2.12753C2.13306 0.97524 2.13837 0.97731 2.14261 0.98089C2.14706 0.98465 2.15005 0.98986 2.15107 0.9956L2.15114 0.996L3.89517 10.585C3.93624 10.8108 4.13295 10.975 4.3625 10.975H11.5C11.7623 10.975 11.975 10.7623 11.975 10.5C11.975 10.2377 11.7623 10.025 11.5 10.025H4.7589L3.08643 0.82941L3.08635 0.829L3.08625 0.82844L2.1358 0.0250001Z"
        fill="#2B2E2E"
      />
      <path
        d="M4.225 11.75C4.225 11.322 4.57198 10.975 5 10.975C5.42802 10.975 5.775 11.322 5.775 11.75C5.775 12.178 5.42802 12.525 5 12.525C4.57198 12.525 4.225 12.178 4.225 11.75ZM5 10.025C4.04731 10.025 3.275 10.7973 3.275 11.75C3.275 12.7027 4.04731 13.475 5 13.475C5.95269 13.475 6.725 12.7027 6.725 11.75C6.725 10.7973 5.95269 10.025 5 10.025Z"
        fill="#2B2E2E"
      />
      <path
        d="M10.725 11.75C10.725 11.322 11.072 10.975 11.5 10.975C11.928 10.975 12.275 11.322 12.275 11.75C12.275 12.178 11.928 12.525 11.5 12.525C11.072 12.525 10.725 12.178 10.725 11.75ZM11.5 10.025C10.5473 10.025 9.775 10.7973 9.775 11.75C9.775 12.7027 10.5473 13.475 11.5 13.475C12.4527 13.475 13.225 12.7027 13.225 11.75C13.225 10.7973 12.4527 10.025 11.5 10.025Z"
        fill="#2B2E2E"
      />
      <path
        d="M11.7563 7.525H11.7564H11.7576H11.7577C11.8797 7.52537 11.9979 7.48273 12.0916 7.40456C12.1853 7.32639 12.2484 7.21771 12.2699 7.0976L12.27 7.09742L12.2702 7.09619V7.09603L12.9305 3.475H3C2.73766 3.475 2.525 3.26234 2.525 3C2.525 2.73766 2.73766 2.525 3 2.525H13.5C13.6409 2.525 13.7745 2.58755 13.8648 2.69574C13.955 2.80394 13.9926 2.94661 13.9673 3.08522L13.2051 7.26498L13.205 7.26523V7.26555C13.144 7.60534 12.9653 7.91281 12.7003 8.13399C12.4352 8.35515 12.1007 8.47588 11.7555 8.475L11.7563 7.525ZM11.7563 7.525H3.90625C3.64391 7.525 3.43125 7.73767 3.43125 8C3.43125 8.26233 3.64391 8.475 3.90625 8.475H11.7555L11.7563 7.525Z"
        fill="#2B2E2E"
      />
    </svg>
  );
}
